module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookDetails"
  }, [_c('div', {
    staticClass: "bookDetails-topBar"
  }, [_c('div', {
    staticClass: "bookDetails-topNav"
  }, [_c('div', {
    staticClass: "bookDetails-topNav-left"
  }, [_c('div', {
    staticClass: "bookDetails-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-topNav-right"
  }, [_c('div', {
    staticClass: "bookDetails-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-subNav"
  }, [_c('ul', [_c('li', {
    staticClass: "bookDetails-introBtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.changeShowIntro()
      }
    }
  }, [_vm._v("作品简介")])]), _vm._v(" "), _c('li', {
    staticClass: "bookDetails-detailsBtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.changeShowDetails()
      }
    }
  }, [_vm._v("内容详情")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-container"
  }, [_c('div', {
    staticClass: "bookDetails-containerInfo"
  }, [(_vm.showIntro) ? _c('div', {
    staticClass: "bookDetails-showIntro"
  }, [_c('div', {
    staticClass: "bookDetails-imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.bookDetail.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-bookIntro"
  }, [_c('p', {
    staticClass: "bookDetail-titleTxt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.title) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-catalogTxt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.catalog) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-tagsTxt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.tags) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-sub1Txt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.sub1) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-readingTxt"
  }, [_vm._v(" 人气：" + _vm._s(_vm.bookDetail.reading) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-bytimeTxt"
  }, [_vm._v(" 时间：" + _vm._s(_vm.bookDetail.bytime) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.showDetails) ? _c('div', {
    staticClass: "bookDetails-showDetails"
  }, [_c('p', {
    staticClass: "bookDetail-sub2Txt",
    domProps: {
      "innerHTML": _vm._s(_vm.bookDetail.sub2)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container-link"
  }, [_c('ul', _vm._l((_vm.linkList), function(linkItem) {
    return _c('li', [_c('a', {
      attrs: {
        "href": linkItem.link
      }
    }, [_vm._v(" " + _vm._s(linkItem.linkName) + " ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "addBookrack"
  }, [_c('a', {
    staticClass: "addBookrackBtn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.addBookrack()
      }
    }
  }, [_vm._v("加入书架")])]), _vm._v(" "), _c('recommend'), _vm._v(" "), _c('bookDetails-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookDetails-titleBox"
  }, [_c('span', {
    staticClass: "bookDetails-title"
  }, [_vm._v("作品详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-317b0ce4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/BookDetails.vue
// module id = 183
// module chunks = 1